export default {
    // Header
  header: {
    house: 'House',
    activities: 'Activities',
    beaches: 'Beaches',
    history: 'History',
    cityGuide: 'City Guide',
    contact: 'Contact',
    phone: '+30 6983446269'
  },

  // Hero Section
  hero: {
    title: 'Create your relax escape in Crete',
    bookNow: 'Book Now',
    phone: '+30 6983446269',
    airbnb: 'Airbnb',
    booking: 'Booking',
    yourRentals: 'YourRentals'
  },

  // House Section
  house: {
    title: 'Azure Loft',
    description: 'Discover Azure Loft, a charming boho apartment in the heart of Crete, designed for ultimate relaxation and comfort. With stunning sea views, warm boho aesthetics, and all modern amenities, it is the ideal choice for couples, families, or friends seeking a unique stay experience.',
    features: [
      'Spaces',
      '1 bedroom in a traditional wooden loft with a comfortable double bed',
      'Dining area with a sofa bed, suitable for an extra guest',
      'Comfortable living room with TV and bright decor',
      'Balcony with table and chairs, perfect for enjoying the unique sea view',
      'Kitchen & Facilities',
      'Fully equipped kitchen with fridge, oven, stovetop, coffee maker, and all necessary utensils',
      'Bathroom with shower, modern sanitary ware, and hot water 24/7',
      'Amenities & Extras',
      'Air conditioning',
      'Washing machine and iron',
      'Clean white linens (sheets, towels, pillows)',
      'Flat-screen TV',
      'Easy parking near the property'
    ],
    bookNow: 'Book now',
    rooms: {
      bedroom: 'Bedroom 1',
      livingRoom: 'Living room',
      bedroom2: 'Bedroom 2',
      kitchen: 'Kitchen',
      veranda: 'Veranda'
    },
    viewPhotos: 'View photos',
    closeGallery: 'Close'
  },

  // Top 5 Reasons
  reasons: {
    title: 'Top 5 Reasons to Stay',
    reason1: {
      title: '1. Breathtaking Views',
      description: 'From the Azure Loft balcony, you\'ll witness a scene straight out of a painting: the endless Cretan Sea, the port of Heraklion in the background, and the sunset colors painting the sky every evening. Perfect for morning coffee and evening wine, with a unique sense of tranquility.'
    },
    reason2: {
      title: '2. The City... Just a Breath Away',
      description: 'Although you\'re in a quiet village, the center of Heraklion is only 15-20 minutes away. There you\'ll find everything you need: from museums and attractions to a vibrant market, restaurants, bars, and cultural events. Access is easy and ideal for day trips.'
    },
    reason3: {
      title: '3. Authentic Crete',
      description: 'Rodia is one of the most beautiful traditional villages in Heraklion. Built on a hill with sea views and filled with stone-paved alleys, small courtyards, and old houses, it offers a sense of authenticity that is rare. It\'s a place where time flows more slowly – and that\'s its greatest privilege.'
    },
    reason4: {
      title: '4. Crystal Clear Beaches',
      description: 'Less than 20 minutes drive from Azure Loft, beaches await for every preference. Ammoudara offers organization and liveliness, Ligaria is ideal for families with clean, calm waters, while Agia Pelagia combines beautiful scenery with good food by the sea. For quieter moments, prefer Made or the picturesque Psaromoura, with crystal blue waters and authentic Cretan atmosphere.'
    },
    reason5: {
      title: '5. For Moments That Last',
      description: 'Azure Loft is ideal for those who want to escape the ordinary and experience something more authentic, human, and peaceful. Whether you\'re traveling with your partner, family, or friends, here you\'ll feel real relaxation and create memories you\'ll remember with a smile.'
    }
  },

  // Reviews
  reviews: [
    {
      author: 'Gerasimos',
      date: '5 months ago',
      rating: 5,
      text: 'We had an excellent experience during our stay at the rental house! The accommodation was spotless, fully equipped, and very comfortable. Its location was ideal, close to everything we needed, but at the same time quiet enough to enjoy our peace. The owner was extremely friendly and helpful, always available to help us with any questions or needs that arose. He also gave us useful advice about the area, such as places to eat and activities. The house had modern decoration, comfortable beds, and everything we needed to feel at home. The Wi-Fi was fast and reliable, which we particularly appreciated. Overall, a fantastic experience that I would definitely recommend to anyone looking for quality accommodation. We can\'t wait to return!'
    },
    {
      author: 'Ioannis Papadakis',
      date: '5 months ago',
      rating: 5,
      text: 'Truly a beautiful warm house with amazing views. We stayed in Heraklion for a short period as our destination was south of Rethymno. The first thing that caught our attention was the view when we made the booking and it really is incredible. Also the house is very clean and smelled nice which is very pleasant when you first enter the villa.'
    },
    {
      author: 'Panagiotis Chandroulidis',
      date: '1 month ago',
      rating: 5,
      text: 'It\'s wonderful with beautiful views. The owner is hospitable and very kind. I recommend you choose it, I\'m sure you\'ll enjoy your stay.'
    },
    {
      author: 'Vasilis',
      date: 'March 2, 2025',
      rating: 5,
      text: 'The house was very beautiful and ideal for romantic getaways. Fully equipped and we could cook😊 The view at night was fantastic from the house along with a glass of wine was something else. The hostess sent us detailed instructions for the house. Quite friendly. Very good impression overall.',
      source: 'booking'
    },
    {
      author: 'Sevi Kallergi',
      date: '23 weeks ago',
      rating: 5,
      text: 'Magical views and comfortable space. It was clean and everything was perfect! Quiet and relaxing. I\'ll definitely go again!'
    },
    {
      author: 'alex tevre',
      date: '24 weeks ago',
      rating: 5,
      text: 'Visiting Crete frequently, I can honestly say that this was one of the best apartments I\'ve ever stayed in! The amazing...'
    },
    {
      author: 'Eirini Vrentzou',
      date: '24 weeks ago',
      rating: 5,
      text: 'Truly wonderful.... I have no words to describe the beauty..everything was perfect and well-maintained...I recommend it without reservation...'
    },
    {
      author: 'Antonis Aerakis',
      date: '24 weeks ago',
      rating: 5,
      text: 'Everything was perfect! Wonderful and clean space with incredible views!'
    },
    {
      author: 'Konstantina Orfanou',
      date: '24 weeks ago',
      rating: 5,
      text: 'Very beautiful space and the hosts are friendly, helpful, and willing to help....'
    },
    {
      author: 'Penny Stathogiannopoulou',
      date: '24 weeks ago',
      rating: 5,
      text: 'Wonderful space with very beautiful aesthetics. Spotless and well-maintained down to the last detail! My favorite place...'
    },
    {
      author: 'MARIA IOANNA RESTIVAKI',
      date: '24 weeks ago',
      rating: 5,
      text: 'If you\'re looking for a peaceful and scenic getaway, this holiday house in Rodia is an excellent choice!...'
    },
    {
      author: 'Maria Stavroulaki',
      date: '24 weeks ago',
      rating: 5,
      text: 'Very beautiful space and combined with the incredible view of Heraklion made our stay unforgettable!!'
    },
    {
      author: 'vasilis maris',
      date: '24 weeks ago',
      rating: 5,
      text: 'I give you my congratulations for how beautiful and renovated your house is. Our stay was wonderful and the...'
    },
    {
      author: 'Manos Papadakis',
      date: '24 weeks ago',
      rating: 5,
      text: 'Very nice views, the tenant very helpful and any problem I had was solved immediately I recommend it without reservation for your holidays whether summer or winter 😁'
    },
    {
      author: 'Panagiotis',
      date: 'June 25, 2025',
      rating: 5,
      text: 'The owner and manager are wonderful people, hospitable and kind. We had a perfect stay and a wonderful collaboration. The house was clean and upon our arrival we were greeted with a nice treat. But the highlight is the balcony, the view is beautiful, you can see all of Heraklion and the endless blue of the sea.',
      source: 'booking'
    },
    {
      author: 'Lise',
      date: 'May 2025',
      rating: 3,
      text: 'Good location to visit the Heraklion area and close to the airport. Small accommodation for 4 people (including children, spiral staircase). Some improvements are needed...',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'April 2025',
      rating: 5,
      text: 'Quiet place with nice views. Communication was excellent.',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'March 2025',
      rating: 5,
      text: 'The house was very clean and the view from the balcony was amazing and you had all the amenities and the host was very friendly and helped me with any problem I had',
      source: 'airbnb'
    }
  ],

  // Reviews Section
  reviewsSection: {
    subtitle: 'What our visitors say!',
    title: 'Reviews'
  },

  // Location Info
  location: {
    title: 'Our Location',
    subtitle: 'A Picturesque Paradise',
    description: 'Azure Loft is located in the enchanting Rodia of Heraklion, a traditional Cretan settlement built amphitheatrically on a hill, with panoramic views of the Cretan Sea and the city of Heraklion. Rodia combines authentic hospitality with unique natural beauty, while serving as an ideal starting point for exploring both the hinterland and the northern coastline of the island.\n\nAt close distance, you can discover crystal clear waters, such as Palaikastro, Ammoudara, and the Ligaria Harbor, ideal for swimming, sunbathing, and water activities.\n\nHistory and culture enthusiasts can easily visit the Archaeological Museum of Heraklion (18 km), the Venetian Walls (17 km), as well as the world-famous Palace of Knossos (21 km). For a family excursion, Cretaquarium – Thalassokosmos is only 33 km away and offers an unforgettable experience for young and old.\n\nThe location of Azure Loft ensures easy access to Heraklion International Airport (20 km), while the accommodation also has free private parking, providing convenience for your transportation.\n\nDiscover the charm of authentic Crete, with the sea as a backdrop and the tranquility of Rodia\'s semi-mountainous landscape.'
  },

  // Calendar
  calendar: {
    title: 'Azure Loft Availability',
    close: 'Close',
    bookAirbnb: 'Book on Airbnb',
    bookBooking: 'Book on Booking',
    bookYourRentals: 'Book on YourRentals',
    requestQuote: 'Request Quote'
  },

  // Footer
  footer: {
    generalInfo: 'General Information',
    location: 'Location',
    getDirections: 'Get Directions',
    contactWays: 'Contact Ways',
    faq: 'Tourist Tax FAQ',
    usefulLinks: 'Useful Links',
    carRental: 'Car Rental',
    busRoutes: 'Bus Routes',
    cityGuide: 'City Guide',
    socialMedia: 'Social Media',
    newsletter: 'Newsletter',
    emailPlaceholder: 'Your email',
    signUp: 'Sign Me Up!',
    copyright: 'Copyright © AZURE LOFT GREECE 2025',
    manual: 'House Manual'
  },

  contact: {
    title: 'Contact Us',
    phone: 'PHONE',
    email: 'EMAIL',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter a valid email address',
    messagePlaceholder: 'Your message',
    submit: 'SUBMIT',
    sending: 'Sending...',
    success: 'Your message was sent successfully!',
    error: 'An error occurred. Please try again.'
  },
  readMore: 'Read more',
  readLess: 'Read less'
}; 